//
import { mapActions, mapState } from "vuex"
import { ModelDataTable } from "@/components/reusable_components/next"

//
import ProviderService from "@/services/api/Purchase/PchProvider"
import filters from "./filters"
import headers from "./headers"

//
export default {
    name: "provider-list",
    components: {
        "crud-data-table": ModelDataTable,
    },
    computed: {
        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        /**
         *
         */
        tableProps() {
            return {
                service: new ProviderService().toList(),
                filters,
                headers,
                rowsPerPage: 25,
            }
        },
    },
    data() {
        return {
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions("MenuesModule", {
            setItemsTopBar: "setItemsTopBar",
            setTitleTopBar: "setTitleTopBar",
        }),
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
            setWarningSnackbar: 'setWarningSnackbar',
        }),

        /**
         * @description
         *
         */
        error() {
            this.setErrorSnackbar(
                'Error al intentar eliminar proveedor.'
            )
        },

        /**
         * @description
         *
         */
        remove(event) {
            //
            this.setWarningSnackbar({
                confirm: 'confirmar',
                message: `¿Confirma la eliminación del proveedor #${ event.item.id }?`,
                title: 'Eliminar',
            })

            //
            this.selected = event.item
        },

        /**
         * @description
         * 
         */
        submitCreate () {
            this.$router.push({ name: "provider-create" })
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: "provider-update",
                params: { id: event.item.id },
            })
        },

        /**
         * @description
         *
         */
        success() {
            this.setSuccessSnackbar(
                'Proveedor eliminado exitosamente.'
            )
        },
    },
    watch: {
        /**
         *
         */
        responseConfirm(val) {
            switch (val) {
                case 'confirmar':
                    return this.selected
                        .delete()
                        .then(this.success)
                        .then(this.$refs.table.refresh)
                        .catch(this.error)
            }
        },
    },
    beforeMount() {

        //
        this.setTitleTopBar("Proveedores")

        // set the view top bar items
        this.setItemsTopBar([
            {
                action  : this.submitCreate,
                color   : "accent",
                icon    : "add_circle",
                text    : "crear proveedor",
                tip     : "Crear nuevo proveedor",
            },
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can("VIEW_ALL_PURCHASE_PROVIDER")) ctx.$router.push("/")
        })
    },
}
